/* Homepage.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _15 = "@media (min-width:64rem) and (max-width:89.99rem){._1acz1gtx{padding:var(--_1bm102r)}}";
const _14 = "@media (min-width:48rem) and (max-width:63.99rem){._13zn1gtx{padding:var(--_1bm102r)}}";
const _13 = "@media not all and (min-width:48rem){._15txwcbu{padding:var(--_4thsry)}}";
const _12 = "._2lx21bp4{flex-direction:column}";
const _11 = "._kqswh2mm{position:relative}";
const _10 = "._zulpxy5q{gap:var(--ds-space-400,2pc)}";
const _9 = "._1yt4ojjz{padding:var(--_8gy4v2)}";
const _8 = "._1wpz1fhb{align-self:stretch}";
const _7 = "._4cvr1h6o{align-items:center}";
const _6 = "._1bah1h6o{justify-content:center}";
const _5 = "._1e0c1txw{display:flex}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable complexity */
import { ApolloError } from '@apollo/client';
import { media } from '@atlaskit/primitives';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { Carousel, FluidContainer, Meta, PartialOutageError, useMpacConfiguration } from '@atlassian/mpac-primitives';
import Telemetry from '@atlassian/mpac-telemetry';
import { MPAC_CONFIGURATION_KEYS } from '@atlassian/mpac-types';
import { ApolloErrorHandler } from '@atlassian/mpac-ui';
import { useEffect, useLayoutEffect } from 'react';
import { BundleSection } from '../components/BundleSection';
import { CategorySection } from '../components/CategorySection';
import { EnterpriseAppsSection } from '../components/EnterpriseAppsSection';
import { FeaturedSection } from '../components/FeaturedSection';
import { H1HeadingBlock } from '../components/H1HeadingBlock';
import { Hero } from '../components/Hero';
import { Sections } from '../components/Sections';
import { SponsoredSection } from '../components/SponsoredSection';
import { TrustSignalsSection, TrustSignalsSectionSkeleton } from '../components/TrustSignalsSection';
import { FeaturedSectionWrapper, HeroWrapper, SectionWrapper } from '../HomepageCommon.styles';
import { useHomepage, useHomepageAnalytics } from '../hooks';
import { HomePageTask } from '../telemetry/tasks';
import { useHomePageTelemetry } from '../telemetry/useHomePageTelemetry';
import { TEST_IDS } from '../testids';
import HeroLeftDesktop from '../assets/Hero_left_desktop.svg';
import HeroMobile from '../assets/Hero_Mobile.svg';
import HeroRightDesktop from '../assets/Hero_right_desktop.svg';
import HeroTablet from '../assets/Hero_Tablet.svg';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const _4 = "._4t3i1osq{height:100%}";
const _3 = "._1bsb1osq{width:100%}";
const _2 = "._kqswstnw{position:absolute}";
const _ = "._1yt4xy5q{padding:var(--ds-space-400,2pc)}";
const CarouselContainerStyle = null;
export const ErrorContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1yt4xy5q _kqswstnw _1bsb1osq _4t3i1osq", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ErrorContainer.displayName = 'ErrorContainer';
}
const HOME_TITLE = 'Explore apps for Atlassian products';
const HOME_TITLE_DESCRIPTION = 'Browse the top apps, add-ons, plugins & integrations for Jira, Confluence, Bitbucket & other Atlassian products. Free 30-day trial for all apps.';
const ErrorSection = _ref2 => {
  let {
    error
  } = _ref2;
  return /*#__PURE__*/_jsx(ApolloErrorHandler, {
    error: error,
    context: {
      page: 'HomePage',
      operationName: 'GetMarketplaceHomePage'
    },
    renderError: () => {
      HomePageTask.failed(error);
      return /*#__PURE__*/_jsx(ErrorContainer, {
        "data-testid": "error",
        children: /*#__PURE__*/_jsx(PartialOutageError, {
          level: "global"
        })
      });
    },
    nonServerErrorCallback: () => HomePageTask.abort()
  });
};
const HeroWrapperStyle = null;
const SectionWrapperStyle = null;

// eslint-disable-next-line max-lines-per-function, complexity
export const Homepage = () => {
  const {
    enableSponsoredAboveExperiment,
    enableSponsoredBelowExperiment,
    enableMpacWebCoherence,
    enableMpacConfigurator,
    enableStaticBundlePagesBelowVariant,
    enableStaticBundlePagesAboveVariant,
    enableHomepageSpotlight,
    enableAppificationChanges,
    enableCategoriesSectionExperiment
  } = useStatsig();
  const isAbove = enableSponsoredAboveExperiment();
  const isBelow = enableSponsoredBelowExperiment();
  const isCategorySectionEnabled = enableCategoriesSectionExperiment();
  const {
    getSectionConfiguration
  } = useMpacConfiguration();
  const spotlightSectionConfiguration = getSectionConfiguration(MPAC_CONFIGURATION_KEYS.homePageBanner);
  const {
    tiles: bannerConfigurations,
    loopDurationInSeconds,
    runInLoop
  } = spotlightSectionConfiguration || {};
  const {
    enterpriseAppsSectionData,
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    areSectionsLoading,
    isSectionsLoadError,
    sponsoredData,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  } = useHomepage();
  const {
    trackTileRenders
  } = useHomepageAnalytics();
  useEffect(() => {
    if (enterpriseAppsSectionData && sectionsData) {
      trackTileRenders(enterpriseAppsSectionData, sectionsData);
    }
  }, [enterpriseAppsSectionData, sectionsData]);
  useHomePageTelemetry({
    isEnterpriseAppsSectionLoading,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionData,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  });
  useLayoutEffect(() => {
    Telemetry.timeToFirstMeaningfulPaint(performance.now());
  }, []);
  if (sectionsDataError && sectionsDataError instanceof ApolloError && (sectionsDataError === null || sectionsDataError === void 0 ? void 0 : sectionsDataError.message) !== 'SECTIONS_APPS_NOT_FOUND') {
    return /*#__PURE__*/_jsx(ErrorSection, {
      error: sectionsDataError
    });
  }
  const metaHomeTitle = enableAppificationChanges() ? 'Explore Marketplace solutions for Atlassian apps' : HOME_TITLE;
  const metaHomeDescription = enableAppificationChanges() ? 'Browse the top Marketplace apps and integrations for Jira, Confluence, Bitbucket & other Atlassian apps. Free 30-day trial for all Marketplace apps.' : HOME_TITLE_DESCRIPTION;
  if (enableMpacWebCoherence()) {
    const enableHomepageSpotlightFlag = enableHomepageSpotlight({
      fireExperimentExposure: true
    });
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Meta, {
        title: metaHomeTitle,
        description: metaHomeDescription
      }), enableHomepageSpotlightFlag && /*#__PURE__*/_jsx(H1HeadingBlock, {}), enableMpacConfigurator() || enableHomepageSpotlightFlag ? Array.isArray(bannerConfigurations) && bannerConfigurations.length ? /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_5, _6]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1e0c1txw _1bah1h6o"]),
          children: /*#__PURE__*/_jsx(Carousel, {
            itemsPerSection: 1,
            autoScroll: runInLoop,
            autoScrollIntervalInSeconds: loopDurationInSeconds,
            showBackground: true,
            children: bannerConfigurations.map((banner, index) => {
              var _banner$isSearchBarIn;
              return /*#__PURE__*/_jsxs(CC, {
                children: [/*#__PURE__*/_jsx(CS, {
                  children: [_5, _7, _8, _6]
                }), /*#__PURE__*/_jsx("div", {
                  className: ax(["_1e0c1txw _4cvr1h6o _1wpz1fhb _1bah1h6o"]),
                  children: /*#__PURE__*/_jsx(Hero, {
                    index: index,
                    eyebrowText: banner === null || banner === void 0 ? void 0 : banner.eyebrowText,
                    heading: banner === null || banner === void 0 ? void 0 : banner.heading,
                    description: banner === null || banner === void 0 ? void 0 : banner.subHeading,
                    heroDesktopLeftImage: banner === null || banner === void 0 ? void 0 : banner.leftBannerImage,
                    heroDesktopRightImage: banner === null || banner === void 0 ? void 0 : banner.rightBannerImage,
                    heroTabletImage: banner === null || banner === void 0 ? void 0 : banner.tabletbannerImage,
                    heroMobileImage: banner === null || banner === void 0 ? void 0 : banner.mobilebannerImage,
                    isSearchBarIncluded: (_banner$isSearchBarIn = banner === null || banner === void 0 ? void 0 : banner.isSearchBarIncluded) !== null && _banner$isSearchBarIn !== void 0 ? _banner$isSearchBarIn : false,
                    heroDesktopImage: banner === null || banner === void 0 ? void 0 : banner.desktopbannerImage,
                    type: banner === null || banner === void 0 ? void 0 : banner.type,
                    redirectUrl: banner === null || banner === void 0 ? void 0 : banner.redirectUrl,
                    ctaText: banner === null || banner === void 0 ? void 0 : banner.ctaText
                  })
                }, index)]
              }, index);
            })
          })
        })]
      }) : /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_5, _7, _8, _6]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1e0c1txw _4cvr1h6o _1wpz1fhb _1bah1h6o"]),
          children: /*#__PURE__*/_jsx(Hero, {
            heading: "Discover apps for your team",
            description: "Enhance your Atlassian experience with Marketplace apps",
            heroDesktopLeftImage: HeroLeftDesktop,
            heroDesktopRightImage: HeroRightDesktop,
            heroTabletImage: HeroTablet,
            heroMobileImage: HeroMobile,
            isSearchBarIncluded: false
          })
        })]
      }) : /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_5, _7, _8, _6]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1e0c1txw _4cvr1h6o _1wpz1fhb _1bah1h6o"]),
          children: /*#__PURE__*/_jsx(Hero, {
            heading: "Discover apps for your team",
            description: "Enhance your Atlassian experience with Marketplace apps",
            heroDesktopLeftImage: HeroLeftDesktop,
            heroDesktopRightImage: HeroRightDesktop,
            heroTabletImage: HeroTablet,
            heroMobileImage: HeroMobile
          })
        })]
      }), isCategorySectionEnabled && /*#__PURE__*/_jsx(FluidContainer, {
        children: /*#__PURE__*/_jsx(CategorySection, {})
      }), /*#__PURE__*/_jsx(FluidContainer, {
        children: isAbove && /*#__PURE__*/_jsx(SponsoredSection, {
          isLoading: areSectionsLoading,
          isError: isSectionsLoadError,
          data: sponsoredData,
          testId: "sponsored-app-section-before"
        })
      }), enableStaticBundlePagesAboveVariant() && /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_9, _10, _11, _5, _12, _8, _13, _14, _15]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1yt4ojjz _zulpxy5q _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1fhb _15txwcbu _13zn1gtx _1acz1gtx"]),
          style: {
            "--_8gy4v2": ix("var(--ds-space-800, 64px)".concat(" 0")),
            "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
            "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
          },
          children: /*#__PURE__*/_jsx(BundleSection, {})
        })]
      }), /*#__PURE__*/_jsx(FluidContainer, {
        children: /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_9, _10, _11, _5, _12, _8, _13, _14, _15]
          }), /*#__PURE__*/_jsx("div", {
            className: ax(["_1yt4ojjz _zulpxy5q _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1fhb _15txwcbu _13zn1gtx _1acz1gtx"]),
            style: {
              "--_8gy4v2": ix("var(--ds-space-800, 64px)".concat(" 0")),
              "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
              "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
            },
            children: /*#__PURE__*/_jsx(FeaturedSection, {})
          })]
        })
      }), enableStaticBundlePagesBelowVariant() && /*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_9, _10, _11, _5, _12, _8, _13, _14, _15]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_1yt4ojjz _zulpxy5q _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1fhb _15txwcbu _13zn1gtx _1acz1gtx"]),
          style: {
            "--_8gy4v2": ix("var(--ds-space-800, 64px)".concat(" 0")),
            "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
            "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
          },
          children: /*#__PURE__*/_jsx(BundleSection, {})
        })]
      }), /*#__PURE__*/_jsxs(FluidContainer, {
        children: [isBelow && /*#__PURE__*/_jsx(SponsoredSection, {
          isLoading: areSectionsLoading,
          isError: isSectionsLoadError,
          data: sponsoredData,
          testId: "sponsored-app-section-after"
        }), /*#__PURE__*/_jsxs(CC, {
          children: [/*#__PURE__*/_jsx(CS, {
            children: [_9, _10, _11, _5, _12, _8, _13, _14, _15]
          }), /*#__PURE__*/_jsx("div", {
            "data-testid": TEST_IDS.SECTION_ENTERPRISE,
            className: ax(["_1yt4ojjz _zulpxy5q _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1fhb _15txwcbu _13zn1gtx _1acz1gtx"]),
            style: {
              "--_8gy4v2": ix("var(--ds-space-800, 64px)".concat(" 0")),
              "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
              "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
            },
            children: /*#__PURE__*/_jsx(EnterpriseAppsSection, {
              isLoading: isEnterpriseAppsSectionLoading,
              isError: isEnterpriseAppsSectionLoadError,
              data: enterpriseAppsSectionData
            })
          })]
        }), !isEnterpriseAppsSectionLoading && /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(Sections, {
            isLoading: areSectionsLoading,
            isError: isSectionsLoadError,
            data: sectionsData
          }), /*#__PURE__*/_jsxs(CC, {
            children: [/*#__PURE__*/_jsx(CS, {
              children: [_9, _10, _11, _5, _12, _8, _13, _14, _15]
            }), /*#__PURE__*/_jsx("div", {
              className: ax(["_1yt4ojjz _zulpxy5q _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1fhb _15txwcbu _13zn1gtx _1acz1gtx"]),
              style: {
                "--_8gy4v2": ix("var(--ds-space-800, 64px)".concat(" 0")),
                "--_1bm102r": ix("var(--ds-space-500, 40px)".concat(" 0")),
                "--_4thsry": ix("var(--ds-space-300, 24px)".concat(" 0"))
              },
              children: areSectionsLoading ? /*#__PURE__*/_jsx(TrustSignalsSectionSkeleton, {}) : /*#__PURE__*/_jsx(TrustSignalsSection, {})
            })]
          })]
        })]
      })]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Meta, {
      title: HOME_TITLE,
      description: HOME_TITLE_DESCRIPTION
    }), /*#__PURE__*/_jsx(HeroWrapper, {
      children: /*#__PURE__*/_jsx(Hero, {
        heading: "Discover apps for your team",
        description: "Enhance your Atlassian experience with Marketplace apps"
      })
    }), isAbove && /*#__PURE__*/_jsx(SponsoredSection, {
      isLoading: areSectionsLoading,
      isError: isSectionsLoadError,
      data: sponsoredData,
      testId: "sponsored-app-section-before"
    }), /*#__PURE__*/_jsx(SectionWrapper, {
      children: /*#__PURE__*/_jsx(FeaturedSectionWrapper, {
        children: /*#__PURE__*/_jsx(FeaturedSection, {})
      })
    }), isBelow && /*#__PURE__*/_jsx(SponsoredSection, {
      isLoading: areSectionsLoading,
      isError: isSectionsLoadError,
      data: sponsoredData,
      testId: "sponsored-app-section-after"
    }), /*#__PURE__*/_jsxs(FluidContainer, {
      children: [/*#__PURE__*/_jsx(SectionWrapper, {
        "data-testid": TEST_IDS.SECTION_ENTERPRISE,
        children: /*#__PURE__*/_jsx(EnterpriseAppsSection, {
          isLoading: isEnterpriseAppsSectionLoading,
          isError: isEnterpriseAppsSectionLoadError,
          data: enterpriseAppsSectionData
        })
      }), !isEnterpriseAppsSectionLoading && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Sections, {
          isLoading: areSectionsLoading,
          isError: isSectionsLoadError,
          data: sectionsData
        }), /*#__PURE__*/_jsx(SectionWrapper, {
          children: areSectionsLoading ? /*#__PURE__*/_jsx(TrustSignalsSectionSkeleton, {}) : /*#__PURE__*/_jsx(TrustSignalsSection, {})
        })]
      })]
    })]
  });
};